import { Box, Stack, Typography } from "@mui/material";
import collegeImg from "../../assets/images/about/college_image_2.jpg";
const About = () => {
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
      >
        <Stack
          sx={{ backgroundColor: "primary.light", p: { xs: 1, md: 3 } }}
          spacing={2}
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          <Box
            p={0.4}
            m={"auto"}
            sx={{
              border: "1px solid #E0E0E0",
              width: { xs: "90%", md: "70%" },
              margin: "auto",
              height: "fit-content",
              display:'flex',
              justifyContent:'center',
            }}
          >
            <img
              src={collegeImg}
              alt="college"
              style={{ width: "80%", height: "80%" }}
            />
          </Box>
          <Typography
            variant="body1"
            textAlign={"justify"}
            p={{ xs: 1, sm: 5 }}
            fontSize={"1rem"}
          >
            <span>
              Progressive Education Society, Pune is a reputed and distinguished
              Educational Institution in Maharashtra. Honourable, Late
              Shankarrao Kanitkar, along with his selfless dedicated team of
              teachers known for the highest moral values, laid the foundation
              of the society on the auspicious day of'Akshay Tritiya' on 16th
              May, 1934 in Pune. P. E. Society has been making noteworthy
              progress for the last 89 years along with the noble path and
              principles laid down by the eminent predecessors such as Guruwarya
              Late S. R. Kanitkar, Late V. T. Tatke and Late M. G. Chaphekar,
              who were illustrious incarnations of ceaseless hard work and
              sacrifice. Late S. R. Kanitkar was ably assisted by Late V. T.
              Tatke, Late M. G. Chaphekar and Late Koparkar. Progressive
              Education Society is proud to possess the glowing tradition of
              these stalwarts.
            </span>
            <br />
            <br />
            <span>
              The two remarkable words that appear in the name of the society
              and its educational institutions are "Progressive" and "Modern".
              The inclusion of these words was certainly with some noble
              intentions, which serves as a bright beacon for P. E. Society to
              follow with determination. The two words viz. 'Progressive' and
              'Modern' highlight the aims and objectives of this reputed
              educational institution. 'Progressive' and 'Modern' were the terms
              used in 1934 by Late S. R. Kanitkar and his colleagues to
              illustrate the dreams and future road map of Progressive Education
              Society, Pune. 'Progressive' means keeping with the spirit of time
              and innovation while 'Modern' means modern in outlook, up-to-date
              in all matters whether it is academic, sports or cultural
              activities. It was resolved to use modern equipment and modern
              methodology to teach the students. The aims and objectives of the
              Progressive Education Society as laid down in its constitution are
              to impart generally to the rising generations of this country and
              particularly to the residents of Maharashtra, an efficient
              pre-primary, primary, secondary, higher secondary and collegiate
              education, embodying a literacy, scientific, technical, commercial
              and industrial training and the training of teachers by the
              establishment at Pune and other places in the Maharashtra, as
              circumstances permit, of pre-primary, primary, secondary, higher
              secondary schools and colleges or by such other means as may be
              most conducive to the attainment of the aims and objects of the
              Progressive Education Society, Pune.
            </span>
            {/* <Typography
              variant="h5"
              my={2}
              fontWeight={"bold"}
              sx={{ textDecoration: "underline" }}
            >
              College Profile -
            </Typography> */}
            <br />
            <br />
            <span>
              PES Modern College of Physiotherapy was established in 2007 with a
              vision to nurture skilled physiotherapy professionals. Initiating
              its academic journey with the Bachelor of Physiotherapy (BPT)
              program affiliated with the Maharashtra University of Health
              Sciences (MUHS), the college welcomed its first batch of 20
              students. Over the years, the college has expanded its capacity to
              accommodate a growing number of aspiring physiotherapists,
              currently admitting 60 students for the BPT program. Recognizing
              the evolving healthcare landscape, Modern College of Physiotherapy
              introduced Master of Physiotherapy (MPT) programs in 2012, also
              affiliated with MUHS. Today, the college offers specialization in
              Musculoskeletal Sciences, Neuro-physiotherapy, Cardiovascular &
              Respiratory Physiotherapy, and Community Physiotherapy, catering
              to the diverse needs of the physiotherapy profession.
            </span>
            <br />
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default About;
